import { Proposal } from "creso-core/types";
import { ArrowUpWideNarrowIcon } from "lucide-react";
import { cn } from "web-design-system";
import { formatProposalStepUp } from "creso-core/utils";

export function StepUpLabel({
  proposal,
  className,
}: {
  // Saved proposal or the builder's form values
  proposal: Pick<
    Proposal,
    "step_up_amount" | "step_up_percentage" | "step_up_frequency"
  > & { total_sip_amount: string | number };
  className?: string;
}) {
  const label = formatProposalStepUp(proposal);
  if (!label || !(Number(proposal.total_sip_amount) > 0)) return null;
  return (
    <span
      className={cn(
        "flex items-center gap-0.5 text-xs text-muted-foreground",
        className
      )}
    >
      <ArrowUpWideNarrowIcon className="size-4 -mt-1" />
      {label}
    </span>
  );
}
